import React, { useEffect, useState } from "react";
import './styles.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import { removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { useSelector } from 'react-redux'
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";

const VisitorOptionMenu = props => {
    let navigate = useNavigate();
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.VISITOR, PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.VISITOR, PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS, employeeSelectedBusiness, employeeSelectedLocation)
        }

    }

    const MENU_OPTIONS = [
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK) ? [{ key: 'VISITOR_BOOK', value: removeSpecialCharAndChangeToPascal('VISITOR_BOOK') }] : []),
        { key: 'ENTRY_QR', value: removeSpecialCharAndChangeToPascal('ENTRY_QR') },
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS) ? [{ key: 'SETTINGS', value: removeSpecialCharAndChangeToPascal('SETTINGS') }] : []),
    ]

    const handleOptionClick = item => {
        switch (item.key) {
            case 'VISITOR_BOOK':
                navigate(ROUTES.visitor.book)
                break
            case 'ENTRY_QR':
                navigate(ROUTES.visitor.entryQR)
                break
            case 'SETTINGS':
                navigate(ROUTES.visitor.settings)
                break
            default:
                break
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Select Option' />
                <div className="pms-option-list-container">
                    {MENU_OPTIONS.map(item => (<div className="pms-ol-item-container" onClick={() => { handleOptionClick(item) }}>
                        <h5 className="pms-oli-label">{item.value}</h5>
                        <div className="pms-oli-img-container">
                            <img src={require('../../../assets/ic_right_icon.png')} className="img" alt="img" />
                        </div>
                    </div>))}
                </div>
            </CommonScreenContent>
        </>
    )
}

export default VisitorOptionMenu